import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { ApiListResponse, TaskDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import merge from "lodash/merge";

import { defaultPage } from "../defaultPage";
import { deadlineDatesToZonedTime } from "./deadlineDatesToZonedTime";
import { taskQueryKeys } from "./taskQueryKeys";

export function useTaskList(
  {
    api,
    opts,
    tz,
  }: {
    api: ApiType;
    tz: string;
    opts: Parameters<ApiType["taskApi"]["find"]>[0];
  },
  queryOpts: Omit<UseQueryOptions<ApiListResponse<TaskDTO>>, "queryKey">,
) {
  return useQuery({
    queryKey: taskQueryKeys.list(opts),
    queryFn: async () => {
      let parsedOpts = merge({}, opts);
      if (opts?.extraParams?.dateFrom) {
        parsedOpts = merge(parsedOpts, {
          extraParams: {
            dateFrom: zonedTimeToUtc(opts.extraParams.dateFrom, tz),
          },
        });
      }
      if (opts?.extraParams?.dateTo) {
        parsedOpts = merge(parsedOpts, {
          extraParams: {
            dateTo: zonedTimeToUtc(opts.extraParams.dateTo, tz),
          },
        });
      }
      return (await api.taskApi.find(parsedOpts)).data;
    },
    initialData: defaultPage<TaskDTO>,
    select: (data: ApiListResponse<TaskDTO>) => {
      return merge({}, data, {
        content: data.content.map((task) => ({
          ...task,
          ...deadlineDatesToZonedTime(task, tz),
        })),
      });
    },
    ...queryOpts,
  });
}
